import { Pipe, PipeTransform } from '@angular/core';
import { MissionNoticeDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'formatNoticeStatusName', pure: true })
export class FormatNoticeStatusNamePipe implements PipeTransform {
    transform(status: MissionNoticeDto.Status, isAcknowledged: boolean): string {
        if (isAcknowledged) {
            return 'Acknowledged'
        }
        switch (status) {
            case MissionNoticeDto.Status.APPLICABLE:
                return 'Applicable';

            case MissionNoticeDto.Status.INFORMATIONAL:
                return 'Informational';

            case MissionNoticeDto.Status.BLOCK:
                return 'Blocked';

            case MissionNoticeDto.Status.NOT_RELEVANT:
            default:
                return 'Not Relevant';
        }
    }
}
